import type { W_Company_CreateCompany_RM } from 'ab-api/web/company/createCompany';
import type { W_Company_Edit_RM } from 'ab-api/web/company/editCompany';

import type { CompanyViewModel } from 'ab-viewModels/company.viewModel';

export class CompanyFormModel {
	aa1?: string;
	aa2?: string;
	aa3?: string;
	country?: string;
	latitude: number;
	locality?: string;
	longitude: number;
	name: string;
	abbreviation: string;
	postalCode?: string;
	route?: string;
	street: string;
	streetNumber?: string;
	website?: string;
	fiscalYearStartMonth?: number;

	deleteImage?: boolean;
	image?: File | string | null;
	imageUrl?: File | string;

	nameChanged?: boolean;

	timezone: string; // Only in view model
	invoiceMessage?: string;

	static toCreateRM(form: CompanyFormModel): W_Company_CreateCompany_RM {
		return {
			aa1: form.aa1,
			aa2: form.aa2,
			aa3: form.aa3,
			country: form.country,
			latitude: form.latitude,
			locality: form.locality,
			longitude: form.longitude,
			name: form.name,
			abbreviation: form.abbreviation,
			postalCode: form.postalCode,
			route: form.route,
			street: form.street,
			streetNumber: form.streetNumber,
			website: form.website,
			fiscalYearStartMonth: form.fiscalYearStartMonth,
			deleteImage: form.deleteImage,
			image: form.image,
			imageUrl: form.imageUrl,
			nameChanged: form.nameChanged,
			timezone: form.timezone,
			invoiceMessage: form.invoiceMessage,
		};
	}

	static toEditRM(form: CompanyFormModel): W_Company_Edit_RM {
		return {
			aa1: form.aa1,
			aa2: form.aa2,
			aa3: form.aa3,
			country: form.country,
			latitude: form.latitude,
			locality: form.locality,
			longitude: form.longitude,
			name: form.name,
			abbreviation: form.abbreviation,
			postalCode: form.postalCode,
			route: form.route,
			street: form.street,
			streetNumber: form.streetNumber,
			website: form.website,
			fiscalYearStartMonth: form.fiscalYearStartMonth,
			deleteImage: form.deleteImage,
			image: form.image,
			imageUrl: form.imageUrl,
			nameChanged: form.nameChanged,
			timezone: form.timezone,
			invoiceMessage: form.invoiceMessage,
		};
	}

	static fromVM(vm: CompanyViewModel): CompanyFormModel {
		return {
			aa1: vm.address?.aa1 ?? undefined,
			aa2: vm.address?.aa2 ?? undefined,
			aa3: vm.address?.aa3 ?? undefined,
			country: vm.address?.country ?? undefined,
			latitude: vm.address?.latitude,
			locality: vm.address?.locality ?? undefined,
			longitude: vm.address?.longitude,
			name: vm.name,
			abbreviation: vm.abbreviation,
			postalCode: vm.address?.postalCode ?? undefined,
			route: vm.address?.route ?? undefined,
			street: vm.address?.street ?? undefined,
			streetNumber: vm.address?.streetNumber ?? undefined,
			website: vm.website ?? undefined,
			fiscalYearStartMonth: vm.fiscalYearStartMonth,
			deleteImage: undefined,
			image: undefined,
			imageUrl: vm.imageUrl ?? undefined,
			nameChanged: false,
			timezone: vm.timezone,
			invoiceMessage: vm.invoiceMessage,
		};
	}
}
